import { onBeforeMount } from 'vue'
import { findAll } from '@/views/plan/api/plan.api'
import { useLocale, useRenamePath, useStorage } from '@locaweb/design-system-vue'
import { SitesRoutesPath } from '@/views/site/router'

export async function useFindPlan (id) {
  const { addPathName } = useRenamePath()
  const t$ = useLocale('plans.plan')
  const [renamePaths] = useStorage({
    key: 'renamePaths',
    initialValue: {},
    type: 'sessionStorage'
  })

  onBeforeMount(async _ => {
    if (!renamePaths.value || !renamePaths.value[`/${id}`]) {
      try {
        const { data } = await findAll()
        data.forEach(plan => {
          addPathName({
            path: SitesRoutesPath.LISTAR.path.replace(':id', plan.id),
            name: t$.name[plan.contract_key]
          })
        })
      } catch (e) {
      }
    }
  })
}
